var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLock3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.91659 6.33333V5.16667C9.91659 3.55584 8.61075 2.25 6.99992 2.25C5.38909 2.25 4.08325 3.55584 4.08325 5.16667V6.33333M6.99992 8.95833V10.125M5.13325 12.75H8.86659C9.84668 12.75 10.3367 12.75 10.7111 12.5593C11.0404 12.3915 11.3081 12.1238 11.4758 11.7945C11.6666 11.4201 11.6666 10.9301 11.6666 9.95V9.13333C11.6666 8.15324 11.6666 7.6632 11.4758 7.28885C11.3081 6.95957 11.0404 6.69185 10.7111 6.52407C10.3367 6.33333 9.84668 6.33333 8.86659 6.33333H5.13325C4.15316 6.33333 3.66311 6.33333 3.28877 6.52407C2.95949 6.69185 2.69177 6.95957 2.52399 7.28885C2.33325 7.6632 2.33325 8.15324 2.33325 9.13333V9.95C2.33325 10.9301 2.33325 11.4201 2.52399 11.7945C2.69177 12.1238 2.95949 12.3915 3.28877 12.5593C3.66311 12.75 4.15316 12.75 5.13325 12.75Z",
    stroke: "#E9BE5C",
    strokeWidth: 1.1389,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock3);
export default __webpack_public_path__ + "static/media/lock3.ed4672acd13880a5db39b7fa3d9385db.svg";
export { ForwardRef as ReactComponent };